import type { InputHTMLAttributes, ReactNode } from 'react'

export type CheckboxPreviewState = 'default' | 'hover' | 'focused' | 'disabled'

export type CheckboxValueState = 'unchecked' | 'checked' | 'indeterminate'

export const CHECKBOX_PREVIEW_STATES: CheckboxPreviewState[] = [
  'default',
  'hover',
  'focused',
  'disabled',
]

export const CHECKBOX_PREVIEW_STATE_LABELS: Record<
  CheckboxPreviewState,
  string
> = {
  default: 'Default',
  hover: 'Hover',
  focused: 'Focused',
  disabled: 'Disabled',
}

export const CHECKBOX_VALUE_STATES: CheckboxValueState[] = [
  'unchecked',
  'checked',
  'indeterminate',
]

export const CHECKBOX_VALUE_STATE_LABELS: Record<CheckboxValueState, string> = {
  unchecked: 'Unchecked',
  checked: 'Checked',
  indeterminate: 'Indeterminate',
}

export type CheckboxProps = {
  label?: ReactNode
  indeterminate?: boolean
  className?: string
  /** dark-mode palette for the control and label. */
  darkMode?: boolean
  /** Static visual state for the design-system showcase only. */
  previewState?: CheckboxPreviewState
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>
